import type { ComponentPropsWithoutRef, ElementRef } from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import * as React from 'react'

import { cn } from '~/lib/utils'

const Progress = React.forwardRef<
  ElementRef<typeof ProgressPrimitive.Root>,
  ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    // Rendu à Radix, et pas seulement à l'indicateur : c'est lui qui pose
    // `aria-valuenow`, sans quoi la barre ne dit rien au lecteur d'écran.
    value={value}
    className={cn(
      'relative h-4 w-full overflow-hidden rounded-full bg-secondary',
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      // Teinte de marque lisible : l'indicateur doit se détacher à 3:1 (RGAA 3.3).
      className="h-full w-full flex-1 bg-primary-text transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
